import {APIClient} from '../utils/APIClient';
import {API_URL} from '../settings/local_settings';
import {notifyOnboardingProgress} from '../utils/onboardingProgress';

// Capa API del objetivo de una línea de control, por prioridad. A diferencia de
// `BusinessUnitEditApi` (paquete entero), este endpoint es PARCIAL: lee y escribe un solo
// objetivo sin tocar presupuesto, período ni nada más de la línea. Es el que usan las celdas de
// objetivo del Tablero; el backend gatea por `user.has_client` y registra el cambio en la Bitácora.
// Payload: `{has_goal, metric_name, value, metric_conversion_configuration}`.
//
// Guardar un objetivo puede cumplir «Deja tu tablero de control listo»: avisa al drawer de «Tus
// primeros pasos» (contrato de la tanda 2026-09-30-alta-leo §4). Hoy lo llama sólo el modal de
// objetivo de la 2.1 (`LineGoalModal`); las celdas del Tablero clásico van por otro camino.
const BASE = API_URL + 'business-unit/';

export const BusinessUnitGoalApi = {
    get(businessUnitId, priority) {
        return new APIClient(`${BASE}${encodeURIComponent(businessUnitId)}/goals/${priority}`).call('GET');
    },

    update(businessUnitId, priority, data) {
        return new APIClient(`${BASE}${encodeURIComponent(businessUnitId)}/goals/${priority}`).call('PUT', data)
            .then(notifyOnboardingProgress);
    },
};
